import { render, staticRenderFns } from "./commission-details-loader.vue?vue&type=template&id=faaafe36"
import script from "./commission-details-loader.vue?vue&type=script&lang=js"
export * from "./commission-details-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports